export default [
    {
        title: "Home",
        route: "home",
        icon: "HomeIcon",
        resource: "Home",
        action: "read"
    },
    {
        title: "User",
        route: "user",
        icon: "UserIcon",
        resource: "User",
        action: "read"
    },
    // {
    //   title: "Master",
    //   icon: "ArchiveIcon",
    //   resource: "Home",
    //   action: "read",
    //   children: [
    //     {
    //       title: "Universitas",
    //       route: "universitas",
    //       icon: "GridIcon",
    //       resource: "Admin",
    //       action: "read",
    //     },
    //     {
    //       title: "Fakultas",
    //       route: "fakultas",
    //       icon: "GridIcon",
    //       resource: "Admin",
    //       action: "read",
    //     },
    //     {
    //       title: "Jurusan",
    //       route: "jurusan",
    //       icon: "GridIcon",
    //       resource: "Admin",
    //       action: "read",
    //     },
    //     {
    //       title: "Platform",
    //       route: "platform",
    //       icon: "GridIcon",
    //       resource: "Member",
    //       action: "read",
    //     },
    //     {
    //       title: "Platform Version",
    //       route: "platformVersion",
    //       icon: "GridIcon",
    //       resource: "Member",
    //       action: "read",
    //     },
    //   ],
    // },
    {
        title: "Members",
        icon: "UsersIcon",
        resource: "Member",
        action: "read",
        children: [
            {
                title: "Pendidikan",
                route: "pendidikan",
                icon: "AwardIcon",
                resource: "Pendidikan",
                action: "read"
            },
            {
                title: "Member",
                route: "member",
                icon: "UsersIcon",
                resource: "Member",
                action: "read",
                children: [
                    {
                        title: "Pre Register",
                        route: "member-status-1",
                        icon: "UsersIcon",
                        resource: "Member",
                        action: "read"
                    },
                    {
                        title: "Registered",
                        route: "member-status-2",
                        icon: "UsersIcon",
                        resource: "Member",
                        action: "read"
                    },
                    {
                        title: "Verified",
                        route: "member-status-3",
                        icon: "UsersIcon",
                        resource: "Member",
                        action: "read"
                    },
                    {
                        title: "Unverified",
                        route: "member-status-4",
                        icon: "UsersIcon",
                        resource: "Member",
                        action: "read"
                    },
                    {
                        title: "Active",
                        route: "member-status-5",
                        icon: "UsersIcon",
                        resource: "Member",
                        action: "read"
                    },
                    {
                        title: "Validated",
                        route: "member-status-6",
                        icon: "UsersIcon",
                        resource: "Member",
                        action: "read"
                    }
                ]
            }
        ]
    },
    {
        title: "Member",
        icon: "UsersIcon",
        resource: "Member-Admin-Fakultas",
        action: "read",
        children: [
            {
                title: "Verified",
                route: "member-status-3",
                icon: "CheckIcon",
                resource: "Member-Admin-Fakultas",
                action: "read"
            },
            {
                title: "Active",
                route: "member-status-5",
                icon: "HeartIcon",
                resource: "Member-Admin-Fakultas",
                action: "read"
            },
            {
                title: "Validated",
                route: "member-status-6",
                icon: "CheckIcon",
                resource: "Member-Admin-Fakultas",
                action: "read"
            }
        ]
    },
    {
        title: "Mentorship",
        icon: "BookIcon",
        resource: "Home",
        action: "read",
        children: [
            {
                title: "Mentor Register",
                route: "mentorship-register",
                icon: "UserCheckIcon",
                resource: "Mentorship",
                action: "read"
            },
            {
                title: "Mentorship List",
                route: "mentorship-schedule",
                icon: "ClockIcon",
                resource: "Mentorship",
                action: "read"
            }
        ]
    }

    // {
    //   title: "Log",
    //   route: "log",
    //   icon: "ListIcon",
    //   resource: "Member",
    //   action: "read",
    // },
];
